import { MY_ACCOUNT_BASE_URL } from "@/constants";
import type { BannerContent } from "./global-banner.types";

/**
 * Gets the appropriate banner content based on current local time and pathname
 * @param now - Current date (defaults to new Date() for easier testing)
 * @param pathname - Current page pathname (optional, used for page-specific banners)
 * @returns Banner content configuration or null if no active promotion
 */
export function getBannerContent(
  now: Date = new Date(),
  pathname?: string,
): BannerContent | null {
  const year = now.getFullYear();
  const currentTime = now.getTime();

  const isInRange = (
    startMonth: number,
    startDay: number,
    startHour: number,
    startMinute: number,
    endMonth: number,
    endDay: number,
    endHour: number,
    endMinute: number,
  ) => {
    const start = new Date(year, startMonth, startDay, startHour, startMinute);
    const end = new Date(year, endMonth, endDay, endHour, endMinute, 59);

    return currentTime >= start.getTime() && currentTime <= end.getTime();
  };

  const isWishlistPage = pathname?.includes("/wishlist");

  // Hide banner on discover sub-pages to avoid content overlap with nav
  // Pattern: /gb/topshop/discover/denim/loose, /gb/topman/discover/denim/skinny, etc.
  const isDiscoverSubPage =
    /^\/(gb\/)?(topshop|topman)\/discover\/[^/]+\/.+/.test(pathname ?? "");
  if (isDiscoverSubPage) {
    return null;
  }

  // Wishlist Perks: 19th Jan 00:00 - 19th Feb 23:59 (wishlist page only)
  const isWishlistPerksPeriod = isInRange(0, 19, 0, 0, 1, 19, 23, 59);

  // Tolu Coker Collab: 19th Feb 17:00 - 1st Mar 23:59
  const isToluCokerCollabPeriod = isInRange(1, 19, 17, 0, 2, 1, 23, 59);

  // Wishlist-specific banner takes priority on wishlist page
  if (isWishlistPage && isWishlistPerksPeriod) {
    return {
      title: "",
      subtitle:
        "ORDERS OVER £40 - FREE STANDARD DELIVERY (NEXT DAY DELIVERY ONLY £2.95)",
      text: "",
      code: "",
      colorScheme: "black",
      clickable: false,
    };
  }

  if (isToluCokerCollabPeriod) {
    return {
      title: "TOLU COKER X TOPSHOP",
      subtitle: "Sign up to be the first in line (02.03.2026)",
      text: "",
      code: "",
      colorScheme: "black",
      clickable: true,
      href: MY_ACCOUNT_BASE_URL,
    };
  }

  return null;
}
